import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import usePageTitle from '../hooks/usePageTitle';
import Header from '../components/Header';
import Footer from '../components/Footer';

const prose = { fontSize: '14px', lineHeight: '1.8', color: '#8b949e' };
const h2style = { fontSize: '17px', fontWeight: 600, color: '#e6edf3', marginBottom: '10px', marginTop: '32px' };

export default function WidgetInfo() {
  const { t } = useTranslation();
  usePageTitle(t('widget.infoPageTitle'));

  const plans = [
    { months: 3,  brl: t('widget.price3Brl'),  usd: t('widget.price3Usd'),  label: t('widget.plan3') },
    { months: 6,  brl: t('widget.price6Brl'),  usd: t('widget.price6Usd'),  label: t('widget.plan6') },
    { months: 12, brl: t('widget.price12Brl'), usd: t('widget.price12Usd'), label: t('widget.plan12') },
  ];

  const features = [
    { icon: '🏆', label: t('widget.iframeStandings'), desc: t('widget.featureStandingsDesc') },
    { icon: '📅', label: t('widget.iframeSchedule'),  desc: t('widget.featureScheduleDesc') },
    { icon: '🏁', label: t('widget.iframeResults'),   desc: t('widget.featureResultsDesc') },
    { icon: '🔌', label: t('widget.jsonApi'),          desc: t('widget.featureApiDesc') },
    { icon: '🎮', label: 'Discord Webhook',            desc: t('widget.featureDiscordDesc') },
  ];

  const discordSteps = [
    t('widget.discordStep1'),
    t('widget.discordStep2'),
    t('widget.discordStep3'),
    t('widget.discordStep4'),
    t('widget.discordStep5'),
  ];

  return (
    <div style={{ minHeight: '100vh', background: '#1b1f23', display: 'flex', flexDirection: 'column' }}>
      <Header />
      <main style={{ flex: 1, maxWidth: '800px', margin: '0 auto', padding: '48px 24px', color: '#c9d1d9' }}>

        <h1 style={{ fontSize: '28px', fontWeight: 700, marginBottom: '8px', color: '#fff' }}>
          {t('widget.sectionTitle')}
        </h1>
        <p style={{ fontSize: '13px', color: '#8b949e', marginBottom: '32px' }}>
          {t('widget.sectionSubtitle')}
        </p>

        <p style={prose}>{t('widget.noSubText')}</p>

        <h2 style={h2style}>{t('widget.infoWhatTitle')}</h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: 12, marginTop: 12 }}>
          {features.map(item => (
            <div key={item.label} style={{ background: '#21262d', border: '1px solid #30363d', borderRadius: 8, padding: '14px 16px' }}>
              <div style={{ fontSize: '20px', marginBottom: 6 }}>{item.icon}</div>
              <div style={{ fontWeight: 600, fontSize: '0.88rem', color: '#e6edf3', marginBottom: 4 }}>{item.label}</div>
              <div style={{ fontSize: '0.78rem', color: '#8b949e' }}>{item.desc}</div>
            </div>
          ))}
        </div>

        <h2 style={h2style}>{t('widget.infoHowTitle')}</h2>
        <p style={prose}>{t('widget.infoHowText1')}</p>
        <p style={{ ...prose, marginTop: 12 }}>{t('widget.infoHowText2')}</p>

        {/* Discord guide */}
        <h2 style={h2style}>{t('widget.discordGuideTitle')}</h2>
        <p style={{ ...prose, marginBottom: 12 }}>{t('widget.discordGuideIntro')}</p>
        <ol style={{ margin: 0, paddingLeft: '1.4rem', display: 'flex', flexDirection: 'column', gap: 8 }}>
          {discordSteps.map((step, i) => (
            <li key={i} style={{ fontSize: '14px', color: '#c9d1d9', lineHeight: '1.6' }}>{step}</li>
          ))}
        </ol>
        <div style={{ background: '#161b22', border: '1px solid #21262d', borderRadius: 6, padding: '10px 14px', marginTop: 14, fontSize: '13px', color: '#8b949e' }}>
          💡 {t('widget.discordGuideTip')}
        </div>

        <h2 style={h2style}>{t('widget.infoPricingTitle')}</h2>
        <p style={{ ...prose, marginBottom: 16 }}>{t('widget.infoPricingDesc')}</p>
        <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
          {plans.map(plan => (
            <div key={plan.months} style={{ background: '#21262d', border: '1px solid #30363d', borderRadius: 10, padding: '18px 20px', minWidth: 150, flex: '1', textAlign: 'center' }}>
              <div style={{ fontWeight: 700, fontSize: '1rem', marginBottom: 8 }}>{plan.label}</div>
              <div style={{ color: '#e8c84a', fontWeight: 800, fontSize: '1.4rem', marginBottom: 2 }}>{plan.brl}</div>
              <div style={{ color: '#9ba3ab', fontWeight: 600, fontSize: '1rem' }}>{plan.usd}</div>
            </div>
          ))}
        </div>

        <h2 style={h2style}>{t('widget.infoWhoTitle')}</h2>
        <p style={prose}>{t('widget.infoWhoText')}</p>

        <div style={{ marginTop: 40, textAlign: 'center' }}>
          <Link
            to="/leagues"
            style={{ background: '#e8c84a', color: '#111', borderRadius: 8, padding: '14px 32px', fontWeight: 700, fontSize: '1rem', textDecoration: 'none', display: 'inline-block' }}
          >
            {t('widget.infoCtaBtn')}
          </Link>
        </div>

      </main>
      <Footer />
    </div>
  );
}
